import _ from 'underscore';
import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { api } from '@culture/common-helpers/request';
import { Controls } from 'components/Controls';
import Chip from 'components/Chip';
import Icon from 'components/Icon';
import Popup from 'components/Popup';

import styles from './styles.module.scss';

const TagList = ({
	tags,
	filters,
	featuredTags,
	onFilterChange,
	apiParams
}) => {
	const [initialTagsList, setInitialTagsList] = useState([]);
	const [tagsList, setTagsList] = useState([]);
	const [value, setValue] = useState(null);
	const [isOpened, setIsOpened] = useState(false);
	const chipRef = useRef();

	useEffect(() => {
		if (apiParams) {
			const { url, dataPath } = apiParams;

			api(url, { ...apiParams.affectQueryParams })
				.then((data) => {
					const items = dataPath ? data[dataPath] : data;
					setTagsList(items);
					setInitialTagsList(items);
					setValue(filters?.tag);
				})
				.catch((err) => {
					throw err;
				});
		} else {
			setValue(filters?.tag);
		}
	}, [tags, filters]);

	const toggleModalHandler = () => {
		setIsOpened((prev) => !prev);
	};

	const closeModal = () => {
		toggleModalHandler();
		setTagsList(initialTagsList);
	};

	const resetTags = () => {
		onFilterChange('tag', null);
	};

	const moreButtonStatus = () => {
		const activeIndex = featuredTags.indexOf((elem) => elem.name === value);

		if (isOpened) {
			return isOpened;
		}
		if (activeIndex >= 0) {
			return true;
		}

		return false;
	};

	const searchHandler = (event) => {
		const searchString = event.target.value.trim().toLowerCase();

		const newTagsList = initialTagsList.filter((tag) =>
			tag.title.trim().toLowerCase().includes(searchString)
		);
		setTagsList(newTagsList);
	};

	const debouncedSearchHandler = _.debounce(searchHandler, 50);

	const selectTagHandler = (event) => {
		const element = event?.target?.closest('button[data-value]');
		if (element !== null) {
			const data = {
				value: element.attributes['data-value'].value
			};

			if (data.value === value) {
				setValue(null);
				onFilterChange('tag', null);
			} else {
				setValue(data.value);
				onFilterChange('tag', data.value);
			}

			setIsOpened(false);
		}
	};

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
		<div onClick={selectTagHandler} className={styles.TagList}>
			<Controls
				childrenWrapperClassName={styles.PopupWrapper}
				right={
					<div className={styles.TagsBar} ref={chipRef}>
						<div className={styles.TagsBar__Block}>
							<Chip onClick={resetTags} title="Все" active={!value} noWrap />
						</div>
						{featuredTags.map(
							(elem) =>
								!_(elem).isEmpty() && (
									<div key={elem._id} className={styles.TagsBar__Block}>
										<Chip
											star={elem?.isImportant}
											title={elem.title}
											value={elem.name}
											active={value === elem.name}
											noWrap
										/>
									</div>
								)
						)}
						<div className={styles.TagsBar__Block}>
							<Chip
								onClick={toggleModalHandler}
								title="Еще..."
								active={moreButtonStatus()}
								theme="outline"
							/>
						</div>
					</div>
				}
			>
				{isOpened ? (
					<Popup
						isOpen={isOpened}
						element={chipRef.current}
						onClickOutside={closeModal}
						placement="bottom-end"
						theme="widget"
						options={{
							strategy: 'absolute',
							modifiers: [
								{
									name: 'flip',
									options: {
										fallbackPlacements: ['bottom']
									}
								}
							]
						}}
						width="mobileFull"
					>
						<div>
							<div className={styles.TagsModal__Header}>
								<span className={styles.TagsModal__Title}>Теги</span>
								<button
									type="button"
									onClick={closeModal}
									className={styles.TagsModal__CloseButton}
								>
									<Icon icon="close" className={styles.TagsModal__CloseIcon} />
								</button>
							</div>
							<div className={styles.TagsModal__InputWrapper}>
								<Icon icon="search" className={styles.TagsModal__SearchIcon} />
								<input
									type="text"
									placeholder="Поиск по тегу"
									className={styles.TagsModal__Search}
									onChange={debouncedSearchHandler}
								/>
							</div>
							<div className={styles.TagsModal__Body}>
								{tagsList.map(
									(elem) =>
										!_(elem).isEmpty() && (
											<div key={elem._id} className={styles.TagsModal__Block}>
												<Chip
													title={elem.title}
													value={elem.name}
													active={value === elem.name}
												/>
											</div>
										)
								)}
							</div>
						</div>
					</Popup>
				) : null}
			</Controls>
		</div>
	);
};

TagList.propTypes = {
	tags: PropTypes.array,
	onFilterChange: PropTypes.func,
	filters: PropTypes.object,
	featuredTags: PropTypes.array,
	apiParams: PropTypes.shape({
		url: PropTypes.string,
		dataPath: PropTypes.string,
		affectQueryParams: PropTypes.shape({})
	})
};

TagList.defaultProps = {
	tags: [],
	featuredTags: []
};

export default TagList;
